import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class GlobalService {
  isValidGUID(value: string | null | undefined): value is string {
    const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return !!value && guidRegex.test(value);
  }
}
